//Core Modules
import React, {Component , Fragment } from "react";

//External Modules
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";

//Internal Modules
import FormHeader from "../../../../Common/FormHeader";
import {
    getFormDetails,
    populateFormDetails,
    loadFormData,
    processSelectList,
    showToast, handleErrorResponse
} from "../../../../Common/Appcommon";
import {setFormDetails} from "../../../../reducers/ThemeOptions";
import ListTable from "../../../../Common/ListTable";
import requestApi from "../../../../services/requestApi.service";
import DeleteConfirm from "../../../../Common/DeleteConfirm";
import MassUpdate from "../../../../Common/MassUpdate";

export default class ListView extends Component {

    formname = "";
    formDetail = [];
    selectedTemplate = [];

    constructor(props) {
        super(props);

        this.formname = props.formname;

        this.state = {
            showLoader : false,
            page:1,
            limit:process.env.REACT_APP_RECORDS_PER_PAGE,
            totalCount: 0,
            formData: [],
            listFields : [],
            fieldsSorting : [],
            templates : [],
            searchTxt : [],
            filterTxt : [],
            selectedTemplate : [],
            showModal : false,
            deleteConfirmModal : false,
            nestedModal : false,
            isMassUpdate : false,
            massSelect : [],
            closeAll : false,
            forceErrorMsg:"",
            settingsAction : props.settingsAction
        };
    }

    componentDidMount = async () => {
        this.setState({
            showLoader : true
        })

        await this.populateFormDetail();
        await this.getTemplatesDetails();
        await this.loadFormData();

        this.setState({
            showLoader : false
        })
    };

    populateFormDetail = async() => {
        this.formDetail = await getFormDetails(this.formname,this.props['formDetails']);
        if(this.formDetail.length === 0){
            this.formDetail = await populateFormDetails(this.formname);
            let newFormDetails = {};
            newFormDetails[this.formname] = this.formDetail;
            await setFormDetails([newFormDetails]);
        }
    }

    getTemplatesDetails = async () => {
        if(this.formDetail && this.formDetail.length > 0) {
            let templates = this.formDetail[4];
            let lastTemplate = this.formDetail[8].length > 0 ? this.formDetail[8][0] : [];
            let lastSelectedTemplateId = lastTemplate.length > 0 ? lastTemplate[2] : '';

            let templateGroups = [];
            let systemTemps = [];
            let publicTemps = [];
            let privateTemps = [];

            for (let key in templates){
                let template = templates[key];
                if(lastSelectedTemplateId === template[0]){
                    this.selectedTemplate = template;
                } else if (lastSelectedTemplateId === ""){
                    lastSelectedTemplateId = template[0];
                    this.selectedTemplate = template;
                }
                if(template[5] === '1'){
                    systemTemps.push(template);
                } else if(template[3] === '1'){
                    publicTemps.push(template);
                } else {
                    privateTemps.push(template);
                }
            }

            templateGroups.push(systemTemps);
            templateGroups.push(publicTemps);
            templateGroups.push(privateTemps);

            this.setState({
                templates : templateGroups,
                selectedTemplate : this.selectedTemplate
            })
        }
    };

    loadFormData = async (issearch=false) => {

        const { rowData , listFields, totalCount } =
            await loadFormData(
                issearch,
                this.formname,
                this.formDetail,
                this.selectedTemplate,
                this.state
            );

        //Manually updating id for user form.
        if(this.formname === process.env.REACT_APP_USER_FORMNAME){
            for(let rowindex in rowData){
                if(rowData[rowindex]['Form ID_id'] !== undefined){
                    rowData[rowindex][this.formname+"_id"] = rowData[rowindex]['Form ID_id'];
                }
            }
        }

        this.setState({
            formData: rowData,
            listFields : listFields[0],
            fieldsSorting : listFields[1],
            totalCount : totalCount
        })
    }

    onPageChange = async (page) => {
        this.setState({page},async ()=>{
            await this.loadFormData();
        });
    }

    handleBtnClick = (name,e,label,value) => {

        let {settingsAction} = this.state;

        let formInfo = this.formDetail[0];
        let moduleName = formInfo[0];
        let formName = formInfo[1];
        let labelName = formInfo[2];
        labelName = labelName.toLowerCase();

        if(settingsAction){
            window.location.href = "#settings"+settingsAction+"/new/"+labelName+"/"+formName;
            window.location.reload();
        }else{
            window.location.href = "#/new/"+labelName+"/"+formName;
        }
    }

    handleChange = async (name, selectedOptions) => {

        if(selectedOptions.templateData !== undefined){
            this.selectedTemplate = selectedOptions.templateData;
            await this.setState({
                selectedTemplate : selectedOptions.templateData,
            });
            await this.loadFormData(true);
        }else {
            let { filterTxt } = this.state;
            filterTxt = await processSelectList(filterTxt, name, selectedOptions);
            this.setState({ filterTxt },async ()=>{
                await this.loadFormData(true);
            });
        }
    }

    handleSearch = async (name,value) => {

        let { searchTxt } = this.state;
        searchTxt[name] = value;
        this.setState({searchTxt},async ()=>{
            await this.loadFormData(true);
        })
    }

    prepareTemplateOptions = (templates) => {

        let viewTemplates = [];

        templates.map((template, index) => {
            let templateList = [];
            template.map((viewTemplate, index) => {
                templateList.push({value : viewTemplate[0], label: viewTemplate[1], templateData: viewTemplate});
            });
            if(index === 0){
                viewTemplates.push({label: "System Templates", options : templateList});
            } else if(index === 1){
                viewTemplates.push({label: "Private Templates", options : templateList});
            } else if(index === 2){
                viewTemplates.push({label: "Public Templates", options : templateList});
            }
        });

        return viewTemplates;
    }

    renderElements =  async (name,formData,fields,childprops) => {
        if(name === 'popupShow'){
            if(fields === "Delete"){
                await this.onMassDeleteAction(childprops);
            } else {
                await this.onMassUpdateAction(childprops);
            }
        }
    }

    onMassUpdateAction = async (selectedRows) =>{
        this.setMassEditOpen(selectedRows);
    }

    onMassDeleteAction = async (selectedRows) =>{
        await this.setSelectedRows(selectedRows);
        await this.massDeleteFormData();
    }

    setSelectedRows = async (selectedRows) => {
        await this.setState({
            massSelect : selectedRows
        })
    }

    setMassEditOpen = (selectedRows) => {
        this.setState({
            isMassUpdate : true,
            massSelect : selectedRows,
        })
    }

    setMassEditClose = () => {
        this.setState({
            isMassUpdate : false,
            massSelect : [],
        })
    }

    massDeleteFormData = async(e, isConfirm = false, isForce = false) => {

        if(!isConfirm){
            await this.toggleModal();
        } else {
            let selectedRowIds = this.state.massSelect;
            let formInfo = this.formDetail[0];
            let moduleName = formInfo[0];
            let params = {
                "ENTITY": "FORMPROCESS",
                "OPERATION": "DELETE",
                "FORMNAME": this.formname,
                "MODULENAME" : moduleName,
                "FORMTYPE" : "",
                "Check Reference" :isForce,
                "FORM_INPUTFIELDS" : selectedRowIds,
                "auditinfo" : {"displaystring":selectedRowIds.length + " Records"},
            }
            let deleteresponse = await requestApi.processServerRequest(params);
            if(deleteresponse.issuccess) {
                let deleteRes = deleteresponse.data;
                if (deleteRes != "" && deleteRes != "Active") {
                    await this.setState({
                        forceErrorMsg: deleteRes,
                    })
                    await this.toggleNestedModal();
                } else {
                    await this.setState({
                        massSelect: [],
                    })
                    if (deleteresponse.errormsg !== ""){
                        showToast(deleteresponse.errormsg, "top-right","success");
                    } else {
                        showToast(selectedRowIds.length + ' records deleted successfully.')
                    }
                    await this.toggleAllModal();
                    await this.loadFormData();
                }
            } else if (deleteresponse.errormsg != ""){
                showToast(deleteresponse.errormsg, "top-right","error");
            }
        }
    }

    updateMassFields = async (e, selectedField, dataRow, fieldDetail) => {

        let {massSelect} = this.state;

        let fieldName = fieldDetail[2];
        let fieldLabel = fieldDetail[3];
        let fieldType = fieldDetail[4];
        let formInfo = this.formDetail[0];
        let moduleName = formInfo[0];
        let fieldValue = dataRow[fieldLabel];
        /*if(fieldType === "ComboBox" || fieldType === "entity_group" || fieldType === "reference"){
            fieldValue = dataRow[fieldLabel]['value'];
            alert(fieldValue);
        }*/
        let fieldValues = {};
        fieldValues[fieldName] = fieldValue;
        let fieldstatus = {};
        fieldstatus[fieldName] = true;
        let auditinfo = {};
        auditinfo["displaystring"] = massSelect.length + " Records";
        let params = {
            "ENTITY": "FORMPROCESS",
            "OPERATION": "MASSEDIT",
            "FORMNAME": this.formname,
            "MODULENAME" : moduleName,
            "FORMTYPE" : "",
            "SUBTABLE_INPUTFIELDS" : [],
            "SUBTABLELINK_INPUTFIELDS" : [],
            "LINEITEM_INPUTFIELDS" : [],
            "BASETABLE_INPUTFIELDS" : [],
            "concurrent_process_confirmed" : false,
            "ids" : massSelect,
            "historyvalues" : [],
            "fieldvalues" : fieldValues,
            "fieldstatus" : fieldstatus,
            "auditinfo" : auditinfo,
        }
        let result = await requestApi.processServerRequest(params, 'WebV2', "post");
        if(result.issuccess){
            showToast(massSelect.length+" records updated successfully.");
        } else {
            handleErrorResponse(result.errormsg);
        }
        this.setMassEditClose();
    }

    onInitiateEditAction = (e, id) => {

        let {settingsAction} = this.state;

        let formInfo = this.formDetail[0];
        let moduleName = formInfo[0];
        let formName = formInfo[1];
        let labelName = formInfo[2];
        labelName = labelName.toLowerCase();

        if(settingsAction){
            window.location.href = "#settings"+settingsAction+"/edit/"+labelName+"/"+formName+"/"+id;
        }else{
            window.location.href = "#/edit/"+labelName+"/"+formName+"/"+id;
        }
    }

    toggleModal = async () => {
        let {deleteConfirmModal} = this.state;
        this.setState({
            deleteConfirmModal : !deleteConfirmModal,
        });
    }

    toggleNestedModal = async () => {

        let {nestedModal} = this.state;

        this.setState({
            nestedModal: !nestedModal,
            closeAll : false
        });
    }

    toggleAllModal = async () => {

        this.setState({
            deleteConfirmModal: false,
            nestedModal : false,
            closeAll : false,
            massSelect : []
        });

    }


    render() {

        let {
            formData,
            listFields,
            templates,
            limit,
            page,
            totalCount,
            selectedTemplate,
            isMassUpdate,
            massSelect
        } = this.state;

        let listFieldName = [];
        let listFieldLabel = [];
        let viewFields = [];
        let headerFieldConfig = {};
        const customFieldConfig = {};

        if(templates === undefined || listFields === undefined || templates.length < 1){
            return <></>;
        }

        listFields.map((field, index) => {
            listFieldName.push(field[2]);
            listFieldLabel.push(field[3]);
            headerFieldConfig[field[3]] = {"class" : "w-5"};
        });

        viewFields.push(listFieldLabel);
        viewFields.push(listFieldLabel);

        const viewTemplates = this.prepareTemplateOptions(templates);

        const selectOptions = [
            {
                'name' : 'Template',
                'placeHolder' : 'Templates',
                'options' : viewTemplates,
                'multiple' : false,
                'selectedTemplate' : {
                    value : selectedTemplate[0],
                    label : selectedTemplate[1],
                    templateData: selectedTemplate
                }
            }
        ];

        let buttonOptions = [
            {
                name : 'create_user',
                label : `Add User`,
                icon : faCirclePlus,
            }
        ]

        const searchOptions = [
            {
                name : 'Name',
                placeHolder : 'Search'
            }
        ];

        const massActions = [
            {
                label: 'Delete', value: 'Delete'
            },
            {
                label: 'Update', value: 'Update'
            },
        ];

        let customRowConfig = {
            link : {
                onClick : this.onInitiateEditAction,
                condition : "",
                class : "row-link"
            }
        }

        return (
            <Fragment>
                <div className="listview-container templates-listview kv-main-wrapper h100per ">
                    <FormHeader
                        buttonOptions={buttonOptions}
                        selectOptions={selectOptions}
                        handleBtnClick={this.handleBtnClick}
                        searchOptions={searchOptions}
                        handleSearch={this.handleSearch}
                        handleSelectChange={this.handleChange}
                        prefix={"user"}
                    />
                    <ListTable
                        key={Math.random()}
                        formData={formData}
                        fields={viewFields}
                        showRowCount={true}
                        spaceBfCell={false}
                        isActionsNeeded={false}
                        isDeleteNeeded={false}
                        isCheckboxNeeded={true}
                        isCheckInfoNeeded={true}
                        isToastNeeded={false}
                        checkBoxPopupData={massActions}
                        customRowConfig={customRowConfig}
                        renderElements={this.renderElements}
                        pagination={true}
                        onPageChange={this.onPageChange}
                        currentPage={page}
                        totalCount={totalCount}
                        limit={limit}
                        prefix = {"user"}
                        customClass={'no-border-table'}
                        headerConfig={headerFieldConfig}
                        formName={this.formname}
                        noDataMsg={`User not found`}
                    />
                    <DeleteConfirm deleteMsg={"The selected records and all related info will be deleted permanently"} form={this} onDelete={this.massDeleteFormData} />
                    <MassUpdate
                        isMassUpdate={isMassUpdate}
                        selectedRows={massSelect}
                        onMassEditClose={this.setMassEditClose}
                        updateMassFields={this.updateMassFields}
                        formname={this.formname}
                        formDetail={this.formDetail}
                    />
                </div>
            </Fragment>
        );
    }

}
